<template>
  <ol>
    <li>
      <NuxtLink to="/">
        <span>Home</span>
      </NuxtLink>
    </li>
    <li v-if="category && categoryLink">
      <NuxtLink :to="categoryLink">
        <span>{{ category }}</span>
      </NuxtLink>
    </li>
    <li v-if="subcategory && subcategoryLink">
      <NuxtLink :to="subcategoryLink">
        <span>{{ subcategory }}</span>
      </NuxtLink>
    </li>
    <li v-if="title">
      <NuxtLink v-if="titleLink" :to="titleLink">
        <span>{{ title }}</span>
      </NuxtLink>
      <span v-else>{{ title }}</span>
    </li>
  </ol>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    titleLink: {
      type: String,
      default: null,
    },
    category: {
      type: String,
      default: null,
    },
    categoryLink: {
      type: String,
      default: null,
    },
    subcategory: {
      type: String,
      default: null,
    },
    subcategoryLink: {
      type: String,
      default: null,
    },
  },
}
</script>

<style scoped>
ol {
  list-style: none;
}
li {
  display: inline;
}
li:after {
  content: ' / ';
  display: inline;
  font-size: 0.9em;
  color: #aaa;
  padding: 0 0.0725em 0 0.15em;
}
li:last-child:after {
  content: '';
}
li a {
  color: #517185;
}
li a.nuxt-link-exact-active.nuxt-link-active {
  color: #517185;
}
</style>